import { useEffect } from 'react';

const useScrollAnimation = () => {
  useEffect(() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const scrollElements = document.querySelectorAll('[data-scroll]');

    if (prefersReducedMotion) {
      scrollElements.forEach((el) => el.classList.add('is-visible'));
      return () => {};
    }

    let observer;
    const timeoutId = setTimeout(() => {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
            }
          });
        },
        {
          root: null,
          rootMargin: '50px 0px -50px 0px',
          threshold: 0.01,
        }
      );

      scrollElements.forEach((el) => observer.observe(el));
    }, 100);

    return () => {
      clearTimeout(timeoutId);
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);
};

export default useScrollAnimation;
